export const AGE_OPTIONS = [
  { label: '12-20', value: '12-20' },
  { label: '21-24', value: '21-24' },
  { label: '25-34', value: '25-34' },
  { label: '35-44', value: '35-44' },
  { label: '45-54', value: '45-54' },
  { label: '55-64', value: '55-64' },
  { label: '65+', value: '65+' },
] as const;

export const TOGGLE_OPTIONS = [
  'homeowner',
  'married',
  'veteran',
  'addHomeInsurance',
] as const;

export const PLATFORM = {
  QUINSTREET: 'QUINSTREET',
  MEDIA_ALPHA: 'MEDIA_ALPHA',
} as const;

export const AUTO_INSURERS = [
  {
    value: 'Allstate',
    label: 'Allstate',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/allstate.png',
  },
  {
    value: 'American Family',
    label: 'American Family',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/american_family.png',
  },
  {
    value: 'Farmers',
    label: 'Farmers Insurance',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/farmers.svg',
  },
  {
    value: 'Geico',
    label: 'GEICO',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/geico.svg',
  },
  {
    value: 'Liberty Mutual',
    label: 'Liberty Mutual',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/libertymutual.png',
  },
  {
    value: 'Nationwide',
    label: 'Nationwide',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/nationwide.png',
  },
  {
    value: 'Progressive',
    label: 'Progressive',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/progressive.svg',
  },
  {
    value: 'State Farm',
    label: 'State Farm',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/state_farm.svg',
  },
  {
    value: 'Travelers',
    label: 'Travelers Insurance',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/travelers.svg',
  },
  {
    value: 'USAA',
    label: 'USAA',
    image: 'https://www.nerdwallet.com/cdn/insurance/logos/usaa.png',
  },
  {
    value: 'Other',
    label: 'Other',
    helper: 'My insurer is not listed',
  },
];
